const CHAIN_ID_MAPPING = {
  1: {
    name: 'Ethereum',
    icon: '/images/coins/eth.svg',
    linkHash: 'https://etherscan.io/tx/',
    linkAddress: 'https://etherscan.io/address/',
    linkTokenId: 'https://etherscan.io/token/',
  },
  56: {
    name: 'Binance Smart Chain',
    icon: '/images/coins/bnb.svg',
    linkHash: 'https://bscscan.com/tx/',
    linkAddress: 'https://bscscan.com/address/',
    linkTokenId: 'https://bscscan.com/token/',
  },
  79: {
    name: 'ETH',
    icon: '/images/coins/eth.svg',
    linkHash: 'https://etherscan.io/tx/',
    linkAddress: 'https://etherscan.io/address/',
    linkTokenId: 'https://etherscan.io/token/',
  },
  97: {
    name: 'Binance Smart Chain - Testnet',
    icon: '/images/coins/bnb.svg',
    linkHash: 'https://testnet.bscscan.com/tx/',
    linkAddress: 'https://testnet.bscscan.com/address/',
    linkTokenId: 'https://testnet.bscscan.com/token/',
  },
  137: {
    name: 'Polygon',
    icon: '/images/icons/polygon.svg',
    linkHash: 'https://polygonscan.com/tx/',
    linkAddress: 'https://polygonscan.com/address/',
    linkTokenId: 'https://polygonscan.com/token/',
  },
}

export default CHAIN_ID_MAPPING
